import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

import {Vehicle} from "@commons/models/domain/Vehicle";
import {VehicleService} from "@commons/services/vehicle/vehicle.service";

@Component({
  selector: 'dsm-selected-vehicles',
  templateUrl: './selected-vehicles.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: SelectedVehiclesComponent,
    multi: true
  }]
})
export class SelectedVehiclesComponent implements ControlValueAccessor, OnInit, OnChanges {

  @Input() isViewMode = false;

  readonly vehicleLimitCount = 14;

  displayedFullVehicles?: Vehicle[];
  inputVehiclesIds?: number[];
  isVehiclesLimitExceeded = false;
  isLoading = true;
  allFullVehicles: Vehicle[] = [];

  get selectedVehiclesCount(): number {
    return this.inputVehiclesIds ? this.inputVehiclesIds.length : 0;
  }

  get isAnyVehicleSelected(): boolean {
    return this.selectedVehiclesCount > 0;
  }

  get vehiclesAboveLimitCount(): number {
    return this.inputVehiclesIds ? this.inputVehiclesIds.length - this.vehicleLimitCount : 0;
  }

  constructor(
    private vehicleService: VehicleService,
  ) {
    this.loadVehicles();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
  }

  onChange: any = () => {
  }

  onTouched: any = () => {
  }

  writeValue(vehicles: number[]): void {
    this.inputVehiclesIds = vehicles;
    this.displayVehicles();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  getVehicleShortName(name: string): string {
    const maxLength = 25;
    return name.slice(0, maxLength) + (name.length >= maxLength ? '...' : '');
  }

  onRemoveVehicle(vehicleId: number) {
    if (!this.isViewMode) {
      this.inputVehiclesIds = this.inputVehiclesIds?.filter(x => x !== vehicleId);
      this.displayVehicles();
      this.onChange(this.inputVehiclesIds);
    }
  }

  onRemoveAll() {
    this.inputVehiclesIds = [];
    this.displayedFullVehicles = [];
    this.onChange([]);
  }

  private loadVehicles() {
    let interval = setInterval(() => {
      if (this.allFullVehicles.length === 0) {
        this.vehicleService.getList$().subscribe(vehicles => {
          this.allFullVehicles = vehicles;
          this.displayVehicles();
        });
      }
      else {
        clearInterval(interval);
      }
    }, 100);
  }

  private displayVehicles() {
    this.isVehiclesLimitExceeded = this.inputVehiclesIds != null && this.inputVehiclesIds?.length > 24;

    const fullVehiclesToDisplay = this.allFullVehicles.filter(v => this.inputVehiclesIds?.some(id => id === v.Id));
    this.displayedFullVehicles = this.isVehiclesLimitExceeded ?
      fullVehiclesToDisplay?.slice(0, this.vehicleLimitCount) : fullVehiclesToDisplay;

    this.isLoading = false;
  }
}
